import { Remitter, RemitterListener } from "remitter";

// 定义事件类型接口
export interface EventTypes {
    "replay-interaction": {
        icon: string;
        from: string;
        to: string;
        toName: string;
        toType: string;
        actionID: string;
    };
    "clear-history-msg": {
        userID: string;
    };
    "send-new-msg": {
        userID: string;
        conversationID?: string;
    };
    "message-received": undefined;
    "channel-layout-type-changed": undefined;
    "refresh-local-avatar": undefined;
    "preview-camera": {
        isPreview: boolean;
        channelItem?: any;
    };
    "confirm-preview-camera": any;
    "update-channels": undefined;
    "show-create-channel": undefined;
    "show-message": {
        message: string;
        type: string;
    };
    "drag-special-effect": {
        to: string;
        isStarted: boolean;
    };
    "scroll-to-msg": {
        msgID: string;
        msgData: any;
    };
    "query-channel-room-list": undefined;
    "load-new-avatar": boolean;
    "user-leave-channel": string;
    "switch-channel": undefined;
    "guide-action": {
        action: "invite" | "customize";
        data: any;
    };
}

// 创建事件总线类
export class EventBus {
    private static instance: EventBus;
    private emitter: Remitter<EventTypes>;

    private constructor() {
        this.emitter = new Remitter<EventTypes>();
    }

    // 获取单例实例
    public static getInstance(): EventBus {
        if (!EventBus.instance) {
            EventBus.instance = new EventBus();
        }
        return EventBus.instance;
    }

    // 订阅事件
    public on<K extends keyof EventTypes>(
        event: K,
        callback: RemitterListener<EventTypes, K>,
    ): () => void {
        return this.emitter.on(event, callback);
    }

    // 发布事件
    public emit<K extends keyof EventTypes>(event: K, data: EventTypes[K]): void {
        this.emitter.emit(event, data);
    }

    // 取消订阅
    public off<K extends keyof EventTypes>(
        event: K,
        callback: RemitterListener<EventTypes, K>,
    ): void {
        this.emitter.off(event, callback);
    }

    // 只订阅一次
    public once<K extends keyof EventTypes>(
        event: K,
        callback: RemitterListener<EventTypes, K>,
    ): () => void {
        return this.emitter.once(event, callback);
    }
}

// 导出单例实例
export const eventBus = EventBus.getInstance();
